import { Divider, Stack, Typography } from '@mui/material';

import useBackupVaults from '@/data/vaults/useBackupVaults';
import dayjs, { DATE_FORMAT, TIME_FORMAT } from '@/utils/dayjs';

import { SnapshotIndicator } from './SnapshotIndicator';

import VaultTag from '../vaults/vaultTag';

export const SnapshotToolbar = ({
  pointInTime,
  vaultId,
  accessDeniedItemsCount,
  hideAccessDeniedItemsCount,
  supportPiTR = false,
}: {
  pointInTime?: Date | null;
  vaultId: string;
  accessDeniedItemsCount?: number;
  hideAccessDeniedItemsCount?: boolean;
  supportPiTR?: boolean;
}) => {
  const { vaults } = useBackupVaults();

  const vault = vaults.find((v) => v.id === vaultId);
  if (!vault) {
    return null;
  }

  return (
    <Stack
      sx={{
        background: 'var(--mui-palette-background-default)',
        margin: '0px 40px',
        padding: '16px 24px',
        borderRadius: '4px',
      }}
      divider={<Divider className='my-[12px]' />}
    >
      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        <Typography>{supportPiTR ? 'PiTR' : 'Snapshot time'}</Typography>
        <Stack direction='row' alignItems='center' gap='12px'>
          <SnapshotIndicator
            backgroundColor={vault.backgroundColor || null}
            isPartial={!!accessDeniedItemsCount}
            isPitr={supportPiTR}
          />
          <Typography>
            {`${dayjs.utc(pointInTime).format(DATE_FORMAT)} at ${dayjs.utc(pointInTime).format(TIME_FORMAT)} UTC`}
          </Typography>
          <Divider orientation='vertical' flexItem className='mx-[12px]' />
          <Typography>Stored in</Typography>
          <VaultTag vault={vault} />
        </Stack>
      </Stack>
      {!!accessDeniedItemsCount && !hideAccessDeniedItemsCount && (
        <Typography>
          {accessDeniedItemsCount === 1
            ? 'This is a partial snapshot. 1 file wasn`t backed up.'
            : `This is a partial snapshot. ${
                accessDeniedItemsCount
              } files weren’t backed up.`}
        </Typography>
      )}
    </Stack>
  );
};
